import { styled } from '@mui/system';
import { useDrag } from 'react-dnd';


const ResizeHandler = styled('div')(({ theme }) => ({
  height: '100%',
  width: theme.spacing(1),
}));


export const Resizer = ({ resizeColumnId, left }: { resizeColumnId?: string; left?: boolean }) => {
  const [_, drag] = useDrag(() => ({
    type: 'Resizer',
    item: { id: resizeColumnId, left }
  }));
  const cursor = left ? 'ew-resize' : 'e-resize';
  return <ResizeHandler ref={drag} style={{ cursor }} />;
};
